import i18next from 'i18next';
import type { CountryCode } from '../constants/countries';
import { COUNTRIES } from '../constants/countries';

type CurrentLocalization = {
  language: string | undefined;
  localizations: Map<CountryCode, string> | undefined;
};

const current: CurrentLocalization = {
  language: undefined,
  localizations: undefined,
};

export const getLocalizedCountryNameFromCode = (countryCode: CountryCode): string => {
  let localizations;
  if (current.localizations !== undefined && current.language === i18next.language) {
    localizations = current.localizations;
  } else {
    const displayNames = new Intl.DisplayNames([i18next.language], { type: 'region' });
    const newLocalizations = new Map<CountryCode, string>();

    COUNTRIES.forEach((country) => {
      // The ES-CN code is not supported by the Intl.DisplayNames API so we have to fallback to i18n.
      if (country.value === 'ES-CN') {
        newLocalizations.set(country.value, i18next.t('common:countries.es-cn'));
        return;
      }

      newLocalizations.set(country.value, displayNames.of(country.value) ?? country.label);
    });

    current.language = i18next.language;
    current.localizations = newLocalizations;
    localizations = newLocalizations;
  }

  const country = localizations.get(countryCode);

  if (country === undefined) {
    return i18next.t('common:countries.unknown');
  }

  return country;
};
